import { AfterViewInit, Component, Inject } from '@angular/core';
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { Store } from '@ngrx/store';
import { GenericListType, LoadMoreQuery } from '../../../common/components/lists/generic-list.component';
import { AppState } from '../../../store';
import { closeKeysModal, getKeysList, loadMoreKeysList, openKeysModal } from '../../store/keys/keys.actions';
import {
  selectAreAllKeysLoadedFlag,
  selectKeys,
  selectKeysErrorFlag,
  selectKeysIsModalOpenFlag,
  selectKeysLoadingFlag,
} from '../../store/keys/keys.selectors';
import { QueryParamsKeysList } from '../../../common/helper/query-params-generic-list.helper';

@Component({
  selector: 'keys-list',
  template: `
    <generic-list
      [type]="type"
      [items]="keys$ | async"
      [isLoading]="keysLoading$ | async"
      [hasNewButton]="true"
      (createClick)="openCreateModal()"
      [newBtnText]="'ssh_key.generic-object.buttons.new' | translate"
      [emptyTitle]="'ssh_key.generic-object.empty.title' | translate"
      [emptyDescription]="'ssh_key.generic-object.empty.description' | translate"
      (loadMore)="loadMoreKeys($event)"
      [allItemsLoaded]="areAllKeysLoaded$ | async"
      [limit]="queryParams.limit"
      [isError]="keysError$ | async"
    >
      <ng-template templateName="listItem" let-item>
        <key-list-item [item]="item"></key-list-item>
      </ng-template>
    </generic-list>
    <xp-modal
      [isOpen]="isModalOpen$ | async"
      [closeButtonText]="'ssh_key.generic-object.buttons.close' | translate"
      [saveButtonText]="'ssh_key.generic-object.buttons.save' | translate"
      [titleText]="'ssh_key.generic-object.title' | translate"
      (close)="onModalClose()"
    >
      <ng-template>
        <key-form></key-form>
      </ng-template>
    </xp-modal>
  `,
})
export class KeysListComponent implements AfterViewInit {
  type = GenericListType.keys;
  keysLoading$ = this.store.select(selectKeysLoadingFlag);
  keysError$ = this.store.select(selectKeysErrorFlag);
  isModalOpen$ = this.store.select(selectKeysIsModalOpenFlag);
  keys$ = this.store.select(selectKeys);
  areAllKeysLoaded$ = this.store.select(selectAreAllKeysLoadedFlag);
  queryParams = QueryParamsKeysList;

  constructor(@Inject('$rootScope') private $rootScope: any, private store: Store<AppState>) {
    this.store.dispatch(getKeysList({ params: this.queryParams }));
  }

  ngAfterViewInit() {
    if (this.$rootScope.stateIs('app.account.settings.my.keys.new')) {
      this.openCreateModal();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  openCreateModal(): void {
    this.$rootScope.stateGo('app.account.settings.my.keys.new');
    this.store.dispatch(openKeysModal());
  }

  onModalClose(): void {
    this.$rootScope.stateGo('app.account.settings.my.keys');
    this.store.dispatch(closeKeysModal());
  }

  loadMoreKeys(query: LoadMoreQuery) {
    const params: any = {
      ...this.queryParams,
      ...query,
    };
    this.store.dispatch(loadMoreKeysList({ params }));
  }
}

((window as any).xplenty as angular.IModule).directive(
  'keysList',
  downgradeComponent({
    component: KeysListComponent,
  }),
);
